import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';import notificationEnumerators from 'src/modules/notification/notificationEnumerators';

export default [
  {
    name: 'title',
    label: i18n('entities.notification.fields.title'),
    schema: schemas.string(
      i18n('entities.notification.fields.title'),
      {},
    ),
  },
  {
    name: 'subject',
    label: i18n('entities.notification.fields.subject'),
    schema: schemas.string(
      i18n('entities.notification.fields.subject'),
      {},
    ),
  },
  {
    name: 'body',
    label: i18n('entities.notification.fields.body'),
    schema: schemas.string(
      i18n('entities.notification.fields.body'),
      {},
    ),
  },
  {
    name: 'status',
    label: i18n('entities.notification.fields.status'),
    schema: schemas.enumerator(
      i18n('entities.notification.fields.status'),
      {
        "options": notificationEnumerators.status
      },
    ),
  },
  {
    name: 'from',
    label: i18n('entities.notification.fields.from'),
    schema: schemas.relationToOne(
      i18n('entities.notification.fields.from'),
      {},
    ),
  },
  {
    name: 'to',
    label: i18n('entities.notification.fields.to'),
    schema: schemas.relationToOne(
      i18n('entities.notification.fields.to'),
      {},
    ),
  },
  {
    name: 'relatedTo',
    label: i18n('entities.notification.fields.relatedTo'),
    schema: schemas.enumerator(
      i18n('entities.notification.fields.relatedTo'),
      {
        "options": notificationEnumerators.relatedTo
      },
    ),
  },
  {
    name: 'relatedResources',
    label: i18n('entities.notification.fields.relatedResources'),
    schema: schemas.relationToMany(
      i18n('entities.notification.fields.relatedResources'),
      {},
    ),
  },
  {
    name: 'relatedAssets',
    label: i18n('entities.notification.fields.relatedAssets'),
    schema: schemas.relationToMany(
      i18n('entities.notification.fields.relatedAssets'),
      {},
    ),
  },
  {
    name: 'relatedLocations',
    label: i18n('entities.notification.fields.relatedLocations'),
    schema: schemas.relationToMany(
      i18n('entities.notification.fields.relatedLocations'),
      {},
    ),
  },
];